import React from 'react'
import CalculatorLabelAndTextDisplay from 'components/CalculatorLabelAndTextDisplay'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const FixedAngleOfViewDisplay = ({ value, bottomRowToggle, classes, uiAction }) => {
  return (
    <div>
      <CalculatorLabelAndTextDisplay titleTag='Horizontal Angle of View' labelText='HAoV'>
        {value}
        <span className={classes.degree}>
          °
        </span>
        <span className={classes.fixed}>
          fixed
        </span>
        { bottomRowToggle &&
          <a
            onClick={uiAction}
            className={classes.bottomRowButton}
            title = 'Show Imager Size and Focal Length'
          >
            <FontAwesomeIcon icon='cog' />
          </a>
        }
      </CalculatorLabelAndTextDisplay>
    </div>
  )
}

export default injectSheet(style)(FixedAngleOfViewDisplay)



// WEBPACK FOOTER //
// ./src/components/AngleOfViewContainer/FixedAngleOfViewDisplay/index.js